import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioListarComponent } from './usuario-listar.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: UsuarioListarComponent }    
    ])],
    exports: [RouterModule]
})
export class UsuarioListarRoutingModule { }
